import { AuConsentStatus, isAuConsentStatus } from '@arrowsup/websites-common';
import * as ss from 'superstruct';

/**
 * Consent status captured with a conversion.
 *
 * The shape and its guard are owned by `@arrowsup/websites-common`; this only
 * adapts the guard to superstruct.  Unknown keys are tolerated (the guard's
 * default) so newer website clients can add flags without being rejected.
 */
export const ConversionConsent = ss.define<AuConsentStatus>(
  'AuConsentStatus',
  (value) => isAuConsentStatus(value) || 'Expected a valid AuConsentStatus',
);

export type ConversionConsent = ss.Infer<typeof ConversionConsent>;
